import { Navigate, useLocation } from 'react-router-dom';
import useParent from '../hooks/useParent.js';

export default function PublicParentRoute({ children }) {
  const { parent } = useParent();
  const location = useLocation();

  if (parent)
    return (
      <Navigate to="/parent/select-child" state={{ from: location }} replace />
    );

  return <>{children}</>;
}
